import React from "react";

// Features with custom icon filenames
const features = [
  { t: "Lightning-Fast Billing", d: "Serve more customers with quick, accurate checkout that reduces queues and errors.", icon: "billing.svg" },
  { t: "Offline-First Reliability", d: "Keep selling even if the internet drops; data syncs automatically when back online.", icon: "offline.svg" },
  { t: "Real-Time Inventory", d: "Live stock, low-stock alerts, smart reorders, batch/expiry, and wastage control.", icon: "inventory.svg" },
  { t: "Customer Loyalty & CRM", d: "Points, vouchers, targeted promos, and rich purchase history.", icon: "loyalty.svg" },
  { t: "Multi-Outlet Control", d: "Centralize pricing, stock transfers, and approvals across branches and franchises.", icon: "multioutlet.svg" },
  { t: "Owner Dashboard", d: "Mobile-ready dashboards with KPIs, heatmaps, top items, margins, and variance.", icon: "dashboard.svg" },
  { t: "Menu & Catalog Flexibility", d: "Combos, variants, modifiers, timed pricing, and seasonal menus.", icon: "menu.svg" },
  { t: "Staff Productivity", d: "Role-based access, cash control, shift reports, and performance insights.", icon: "staff.svg" },
  { t: "E-invoicing & Compliance", d: "VAT/GST support, regional formats, multi-currency and localization.", icon: "invoice.svg" },
  { t: "Omnichannel Ready", d: "Armada Online Ordering (commission-less) + integrations with leading platforms.", icon: "omnichannel.svg" },
  { t: "Rapid Setup & Migration", d: "Import SKUs/recipes, carry historical data, and go live fast with training.", icon: "setup.svg" },
  { t: "Secure Cloud Backups", d: "Encrypted storage, audit trails, and safe restore options anytime.", icon: "backup.svg" },
];

export default function Features() {
  return (
    <section id="features" className="py-16 md:py-20 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4">
        {/* Section header */}
        <h2 className="text-2xl md:text-3xl font-extrabold">Why Choose Armada POS?</h2>
        <p className="mt-2 text-slate-600 max-w-3xl">
          A modern POS that’s fast on the counter, smart in the back office, and built to scale from one store to hundreds.
        </p>

        {/* Features grid */}
        <div className="mt-8 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((f, i) => (
            <div
              key={i}
              className="rounded-2xl border bg-white p-5 shadow-sm hover:shadow transition"
            >
              {/* Icon */}
              <div className="w-10 h-10 flex items-center justify-center mb-3">
                <img
                  src={`/icons/${f.icon}`}  
                  alt={f.t}
                  className="w-8 h-8 object-contain"
                />
              </div>

              {/* Title + description */}
              <h3 className="font-bold text-slate-900">{f.t}</h3>
              <p className="mt-1 text-slate-600">{f.d}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
